<template>
  <div class="grid-container" ref="gridContainer">
    <div class="grid-container-p"><p>{{ $t('series.two_height') }}<br><span style="color: white">9/6 CM</span></p></div>
    <!-- 宫格项目 - 响应式布局 -->
    <div v-for="(item, index) in gridData" :key="index" class="grid-item">
      <div class="control-line">
        <div class="first-line">
          <div class="text-border" :data-type="`title-${index}`">{{ item.title }}</div>
        </div>
        <div class="second-line">
          <span class="height_description" :data-type="`desc-${index}`">{{ item.description }}</span>
          <span class="size" :style="{ color: item.sizeColor }" :data-type="`size-${index}`">{{ item.size }}</span>
          <span class="unit" :style="{ color: item.sizeColor }" :data-type="`unit-${index}`">{{ item.unit }}</span>
        </div>
      </div>
      <div class="third-line">
        <img
            :src="item.imageUrl"
            :alt="item.altText"
            class="item-image-hei"
            :data-type="`image-${index}`"
        >
      </div>
    </div>
  </div>
</template>
<script>
import image1 from '../../static/series/cutbed/cut_height1.png'
import image2 from '../../static/series/cutbed/cut_height2.png'

export default {
  name: 'CutHeight',
  data() {
    return {
      gridData: [
        {
          title: 'S9',
          description: this.$i18n.t('series.MaxCuttingThickness'),
          size: '9',
          unit: 'cm',
          sizeColor: '#83cbeb',
          titleColor: '#808080',
          descColor: '#808080',
          imageUrl: image1,
          altText: '裁剪厚度展示图'
        },
        {
          title: 'S6',
          description: this.$i18n.t('series.MaxCuttingThickness'),
          size: '6',
          unit: 'cm',
          sizeColor: '#e59edd',
          titleColor: '#808080',
          descColor: '#808080',
          imageUrl: image2,
          altText: '材料宽度展示图'
        }
      ],
      isMobile: false
    };
  },
  methods: {
    checkDevice() {
      this.isMobile = window.innerWidth <= 768;
    },
    handleResize() {
      this.checkDevice();
    }
  },
  mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.handleResize);

    this.$nextTick(() => {
      const container = this.$refs.gridContainer;
      const isMobile = this.isMobile;
      const items = document.querySelectorAll('.grid-container-p > *');
      const imageElements = document.querySelectorAll(".item-image-hei");
      const textElements = document.querySelectorAll(".control-line");

      this.$gsap.set([items, imageElements, textElements], {
        visibility: 'visible'
      });

      this.$gsap.set(items, {
        y: isMobile ? 60 : 100,
        opacity: 0
      });

      this.$gsap.set(imageElements, {
        opacity: 0
      });

      this.$gsap.set(textElements, {
        y: isMobile ? 30 : 50,
        x: isMobile ? 30 : 50,
        scale: isMobile ? 0.85 : 0.8,
        opacity: 0
      });

      const mainTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: isMobile ? 'top 90%' : 'top 100%',
          end: isMobile ? 'bottom 30%' : 'bottom 20%',
          toggleActions: 'play none none none',
          markers: false,
          once: true
        }
      });

      // 标题入场动画
      items.forEach((item, index) => {
        mainTimeline.to(item, {
          y: 0,
          opacity: 1,
          duration: isMobile ? 0.9 : 1,
          ease: 'power2.in'
        }, index * 0.1);
      });

      // 图片入场动画（移动端调整为完整显示）
      mainTimeline.to(imageElements, {
        x: isMobile ? 0 : -350, // 移动端无水平偏移，确保完整显示
        y: isMobile ? -20 : -50,
        opacity: 1,
        duration: isMobile ? 1.3 : 1.5,
        ease: 'power2.in'
      }, isMobile ? 0.8 : 1);

      // 文本入场动画
      mainTimeline.to(textElements, {
        x: 0,
        y: 0,
        opacity: 1,
        duration: isMobile ? 1.3 : 1.5,
        scale: 1,
        ease: 'power3.in'
      }, isMobile ? 0.8 : 1);

      mainTimeline.to({}, {duration: 0.5});
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style scoped>
/* 电脑端样式保持不变 */
.grid-container {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  gap: 2rem;
  padding: 3rem 5%;
  width: 100%;
  background-color: #000;
  box-sizing: border-box;
  overflow: hidden;
  height: auto;
  min-height: 750px;
  will-change: transform, opacity;
}

.grid-container-p {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 100px;
}

.grid-container p:nth-of-type(1) {
  font-size: 2.5em;
  color: #808080;
  text-align: left;
  line-height: 1.2;
}

.grid-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2.5rem;
  box-sizing: border-box;
  min-height: 350px;
  transition: transform 0.3s ease;
  margin-top: 100px;
}

.first-line {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}

.text-border {
  position: relative;
  padding-top: 12px;
  font-size: 2em;
  color: #808080;
  text-align: left;
  letter-spacing: 0.5px;
  display: inline-block;
}

.text-border::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #808080;
}

.second-line {
  font-size: 1.5em;
  display: flex;
  align-items: baseline;
  flex-wrap: nowrap;
  gap: 0.3rem;
  width: 100%;
  margin-top: 1rem;
}

.height_description {
  color: #808080;
}

.size {
  font-size: 2.2rem;
  font-weight: bold;
}

.unit {
  font-size: 1.5rem;
}

.third-line {
  width: 100%;
  display: flex;
  justify-content: center; /* 图片容器居中 */
  align-items: center;
  padding: 1rem 0;
  overflow: visible; /* 允许图片完整显示 */
}

.item-image-hei {
  position: absolute;
  width: 700px;
  margin-top: 350px;
  height: 35%;
  object-fit: contain; /* 保持图片比例完整显示 */
}

.item-image-hei[data-type="image-0"] {
  left: 0;
}

.item-image-hei[data-type="image-1"] {
  right: -300px;
}

.control-line {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 50px;
  margin-top: 50px;
}

/* 手机端适配（重点确保图片完整显示） */
@media (max-width: 768px) {
  .grid-container {
    grid-template-columns: 1fr;
    gap: 2rem;
    padding: 3rem 5% 8rem; /* 增加底部 padding 防止图片被截断 */
    min-height: auto;
    overflow: visible; /* 允许内容溢出容器显示 */
  }

  .grid-container-p {
    margin-top: 30px;
    padding: 0 5%;
  }

  .grid-container p:nth-of-type(1) {
    font-size: 2em;
    text-align: left;
    margin-left: 0;
  }

  .grid-item {
    padding: 2.5rem 5%;
    min-height: auto;
    margin-top: 80px;
    position: relative; /* 相对定位，确保图片在项目内 */
    padding-bottom: 300px; /* 预留图片显示空间 */
  }

  .text-border {
    font-size: 1.8em;
    padding-top: 10px;
    letter-spacing: 0.4px;
  }

  .second-line {
    font-size: 1.35em;
    flex-wrap: nowrap;
    gap: 0.3rem;
    margin-top: 0.9rem;
  }

  .size {
    font-size: 2rem;
  }

  .unit {
    font-size: 1.35rem;
  }

  .third-line {
    justify-content: center; /* 图片居中 */
    padding: 1rem 0 0;
    position: absolute; /* 绝对定位在项目底部 */
    bottom: 0;
    left: 0;
  }

  .item-image-hei {
    position: relative; /* 相对定位确保完整显示 */
    width: 100%; /* 图片宽度适应容器 */
    max-width: 400px; /* 限制最大宽度 */
    margin-top: 20px; /* 调整与文字的距离 */
    height: auto; /* 自动高度保持比例 */
    object-fit: contain; /* 确保图片完整显示不裁剪 */
  }

  /* 取消左右偏移，确保图片居中完整显示 */
  .item-image-hei[data-type="image-0"],
  .item-image-hei[data-type="image-1"] {
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
  }

  .control-line {
    margin-left: 40px;
    margin-top: 40px;
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .grid-item {
    padding-bottom: 250px; /* 调整预留空间 */
  }

  .grid-container p:nth-of-type(1) {
    font-size: 1.8em;
  }

  .second-line {
    font-size: 1.2em;
  }
}

/* 平板适配保持不变 */
@media (min-width: 769px) and (max-width: 1024px) {
  .grid-container {
    gap: 1.5rem;
    padding: 2.5rem 4%;
  }

  .item-image-hei {
    width: 500px;
  }
}
</style>
